export default __webpack_public_path__ + "static/media/whatsapp.019c2d4e.png";